// index.tsx
import * as React from 'react';
import { Box, Grid, Container, Typography, List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageProps } from '../../types/navigationProperties';
import PageHeader from '../../components/PageHeader';
import Footer from '../../components/Footer';
import { SetButtonCallbackFunction } from '../../types/callback';
import { SEO } from '../../components/SEO';
import { MetaTag } from '../../services/SEOServiceProvider';
import aboutPage from '../../assets/img/about_page.jpg';

export default function TermsAndConditions({ props, setPageName, metaTags }: { props: PageProps, setPageName: SetButtonCallbackFunction, metaTags: MetaTag[] }) {

    const { t } = useTranslation();
    const [metaTag, setMetaTag] = React.useState<MetaTag>();

    React.useEffect(() => {
        setPageName('terms-and-conditions');
        let metaTagData = metaTags !== undefined && metaTags.filter((item: MetaTag) => item.page === 'terms-and-conditions' );
        if(metaTagData && metaTagData.length > 0) {
            let termsPageMetaTag: MetaTag = {...metaTagData[0]} as MetaTag;
            termsPageMetaTag.url = window.location.href;
            termsPageMetaTag.image = aboutPage;
            setMetaTag(termsPageMetaTag);
        }

    }, [setPageName, metaTags]);

    const headingProps = {
        title: t("terms.and.conditions.title.1"),
        description: t("terms.and.conditions.title.1.sub")
    };

    return (
        <Box>
            <SEO metaTag={metaTag} />
            <Box>
                <PageHeader props={headingProps} />
            </Box>
            <Box sx={{ py: '40px', px: '20px', paddingTop: { xs: '20px', sm: '20px', md: '40px' }, bgcolor: 'primary.light' }}
                 style={{ width: '100%', height: '100%' }}>
                <Container maxWidth="lg" sx={{ paddingTop: '20px' }}>
                    <Grid direction='row' rowSpacing={4}>
                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' }
                              }} >
                            {t('terms.and.conditions.heading.1')}
                        </Typography>
                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.1.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.1.description')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.2.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.2.description')}
                        </Typography>

                        <List>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.1.sub')}</span> {t('terms.and.conditions.heading.2.description.1.description')}
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.2.sub')}</span> {t('terms.and.conditions.heading.2.description.2.description')}
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.3.sub')}</span> {t('terms.and.conditions.heading.2.description.3.description')}
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.4.sub')}</span> {t('terms.and.conditions.heading.2.description.4.description')}
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.5.sub')}</span> {t('terms.and.conditions.heading.2.description.5.description')}
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.6.sub')}</span> {t('terms.and.conditions.heading.2.description.6.description')}
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.7.sub')}</span> {t('terms.and.conditions.heading.2.description.7.description')}
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.8.sub')}</span> {t('terms.and.conditions.heading.2.description.8.description')}
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>{t('terms.and.conditions.heading.2.description.9.sub')}</span> {t('terms.and.conditions.heading.2.description.9.description')}
                                </Typography>
                            </ListItem>
                        </List>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.3.sub')}
                        </Typography>
                        <Typography sx={{ paddingBottom: '6px' }}>
                            {t('terms.and.conditions.heading.3.description.1')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.3.description.2')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.3.description.3')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.3.description.4')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.3.description.5')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.4.sub')}
                        </Typography>
                        <Typography sx={{ paddingBottom: '6px' }}>
                            {t('terms.and.conditions.heading.4.description.1')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.4.description.2')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.4.description.3')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.5.sub')}
                        </Typography>
                        <Typography sx={{ paddingBottom: '6px' }}>
                            {t('terms.and.conditions.heading.5.description.1')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.5.description.2')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.6.sub')}
                        </Typography>
                        <Typography sx={{ paddingBottom: '6px' }}>
                            {t('terms.and.conditions.heading.6.description.1')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.6.description.2')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.6.description.3')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.7.sub')}
                        </Typography>
                        <Typography sx={{ paddingBottom: '6px' }}>
                            {t('terms.and.conditions.heading.7.description.1')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.7.description.2')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.7.description.3')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.8.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.8.description.1')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.9.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.9.description.1')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.10.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.10.description.1')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.11.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.11.description.1')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.title.2')}
                        </Typography>
                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               paddingBottom: '20px'
                              }} >
                            {t('terms.and.conditions.heading.12.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.12.description.1')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.13.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.13.description.1')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.14.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.14.description.1')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.15.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.15.description.1')}
                        </Typography>

                        <Typography sx={{
                               fontSize: { sm: '14px', md: '16px', lg: '18px' },
                               py: '20px'
                              }} >
                            {t('terms.and.conditions.heading.16.sub')}
                        </Typography>
                        <Typography>
                            {t('terms.and.conditions.heading.16.description.1')}
                        </Typography>
                        <Typography sx={{ py: '6px' }}>
                            {t('terms.and.conditions.heading.16.description.2')}
                        </Typography>
                    </Grid>
                </Container>
            </Box>
            <Footer {...props} />
        </Box>
    );
}
